module.exports = __webpack_public_path__ + "img/informage.7d5812a7.png";